import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useIntl } from 'react-intl';
import { IconButton } from '../../design-system';
import { useSettings } from '../../context/SettingsContext/useSettings';

const buttonStyles = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  right: 0,
  width: 24,
  height: 24,
  p: 0,
  opacity: 0,
  '& > svg': { fontSize: 14 },
  '[data-selected-entity-card]:hover &, [data-selected-entity-card]:focus-within &': {
    opacity: 1,
  },
  '@media (hover: none)': { opacity: 1 },
};

export const SelectedEntityCloseButton = () => {
  const intl = useIntl();
  const { setSelectedEntity } = useSettings();
  const handleClose = () => setSelectedEntity(null);

  return (
    <IconButton
      size="small"
      tone="neutral"
      variant="filled"
      aria-label={intl.formatMessage({
        id: 'action.close',
        defaultMessage: 'Close',
      })}
      onClick={handleClose}
      sx={buttonStyles}
    >
      <CloseIcon />
    </IconButton>
  );
};
